import React, { useEffect, useState } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";
import { toast } from "react-toastify";
import API from "../../Network/API";
import TimeZone from "../../CustomHooks/TimeZone";
import MeetingShare from "./MeetingShare";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

export default function AddMeetingSchedule(props) {
  const [modalDialog, setModalDialog] = useState(false);

  const toggleModal = () => {
    setModalDialog(!modalDialog)
  };
  const {t} = useTranslation()
  const [check_box,setCheckbox]=useState(false)
  const [loading, setLoading] = useState(false);
  const [title, setTitle] = useState(null);
  const [date, setDate] = useState(null);
  const [time_zone, setTimeZone] = useState('Europe/London');
  const [time, setTime] = useState(null);
  const [password, setPassword] = useState('');
  const [note, setNote] = useState('');
  const [sendToShareData, setSendToShareData] = useState('');
  // const [data] = useFetch("https://jsonplaceholder.typicode.com/todos");
  const fileObj = [];
  const fileArray = [];
  const fileArrayAnother = [];
  const [file, setFile] = useState([]);
  const [timezonename, setTimezoneText] = useState('');

  const usert_timez = useSelector((state) => state.timeZoneReducer)

  const getCurrentTimezone = () => {
    const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    setTimezoneText(userTimezone);
  };

  const handleSubmit = event => {
    event.preventDefault();

    if (typeof title === null) {
      toast.error('Please add title.');
      return false;
    }
    if (typeof time_zone === null) {
      toast.error('Please add time_zone.');
      return false;
    }
    const fd = new FormData();
    fd.append('title', title);
    fd.append('date', date);
    fd.append('time_zone', time_zone);
    fd.append('time', time);
    fd.append('note', note);
    fd.append('password', null);
    if(event.target.is_recurring.checked){
      fd.append('is_repeated', 1);

      if(event.target.recurring_type.value==""){
        alert("Please select recurrence type");
        return;
      }
      fd.append('recurring_type', event.target.recurring_type.value);

    }else{
      fd.append('is_repeated', 0);
      fd.append('recurring_type', 0);
    }
    

    setLoading(true);
    if (fileObj.length > 0) {
      for (var i = 0; i < fileObj.length; i++) {
        fd.append('img', fileObj[i], fileObj[i].name);
      }
    }

    API.post('/v3/myScheduleCreate', fd).then(response => {
      setLoading(false);
      if (response.data.success === true) {
        props.handleShowB()
        setSendToShareData(response.data.data)
        toggleModal()
      }
    }).catch((error) => {
      setLoading(false);
      toast.error(error.response.data.sms);
    });
  }

  const uploadHandler = (e) => {
    fileObj.pop();
    fileObj.push(e.target.files[0])

  }

  useEffect(() => {
    getCurrentTimezone();
  }, []);


  return (
    <>
      <Modal
        isOpen={props.isModalVisible}
        size=""
        toggle={props.handleShowB}
        className={'modal-dialog modal-dialog-scrollable'} backdrop="static"
      >
        <ModalHeader className="border-0 pb-2" toggle={props.handleShowB} id={'staticBackdropLabel'}>
          <h5 className="modal-title fw-bold text-dark mb-0">{t('Schedule Your Meeting')}</h5>
        </ModalHeader>
        <ModalBody className="bg-white px-4 py-0">
          <div className="meeting-schedule-popup">
            <form onSubmit={handleSubmit}>
              <div className="py-3">
                <p className="text-muted small mb-2" style={{fontSize: '12px'}}>
                  <span className="text-danger">*</span> {t('marked are required')}
                </p>
                
                <div className="row g-2 mb-3">
                  <div className="col-md-6">
                    <label htmlFor="Title" className="form-label fw-medium text-dark mb-1" style={{fontSize: '13px'}}>
                      {t('Meeting Title')} <span className="text-danger">*</span>
                    </label>
                    <input 
                      type="text" 
                      onChange={(e) => setTitle(e.target.value)} 
                      className="form-control py-2 px-3 rounded-2" 
                      id="Title" 
                      placeholder="Enter meeting title" 
                      style={{fontSize: '14px', borderColor: '#e9ecef'}}
                      required 
                    />
                  </div>
                  <div className="col-md-6">
                    <label htmlFor="date" className="form-label fw-medium text-dark mb-1" style={{fontSize: '13px'}}>
                      {t('Date')} <span className="text-danger">*</span>
                    </label>
                    <input 
                      type="date" 
                      onChange={(e) => setDate(e.target.value)} 
                      className="form-control py-2 px-3 rounded-2" 
                      id="date" 
                      style={{fontSize: '14px', borderColor: '#e9ecef'}}
                      required 
                    />
                  </div>
                </div>

                <div className="row g-2 mb-3">
                  <div className="col-md-6">
                    <label htmlFor="time" className="form-label fw-medium text-dark mb-1" style={{fontSize: '13px'}}>
                      {t('Time')} <span className="text-danger">*</span>
                    </label>
                    <input 
                      type="time" 
                      onChange={(e) => setTime(e.target.value)} 
                      className="form-control py-2 px-3 rounded-2" 
                      id="time" 
                      style={{fontSize: '14px', borderColor: '#e9ecef'}}
                      required 
                    />
                  </div>
                  <div className="col-md-6">
                    <label htmlFor="inputState" className="form-label fw-medium text-dark mb-1" style={{fontSize: '13px'}}>
                      {t('Time Zone')} <span className="text-danger">*</span>
                    </label>
                    <select
                      id="inputState"
                      onChange={(e) => setTimeZone(e.target.value)}
                      defaultValue={usert_timez?.timezone}
                      className="form-select py-2 px-3 rounded-2"
                      style={{fontSize: '14px', borderColor: '#e9ecef'}}
                      required
                    >
                      {TimeZone()?.map((zoneName, index) => (
                        <option
                          key={index}
                          value={zoneName}
                          selected={usert_timez?.timezone === zoneName}
                        >
                          {zoneName}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>

                <div className="mb-3">
                  <div className="form-check d-flex align-items-center">
                    <input 
                      onChange={()=>setCheckbox(!check_box)} 
                      type="checkbox" 
                      className="form-check-input me-2" 
                      id="is_recurring" 
                      name="is_recurring"
                      style={{transform: 'scale(1.1)'}}
                    />
                    <label htmlFor="is_recurring" className="form-check-label fw-medium text-dark mb-0" style={{fontSize: '13px'}}>
                      {t('Recurring Meeting')}
                    </label>
                  </div>
                  {check_box && (
                    <div className="mt-2">
                      <select 
                        className="form-select py-2 px-3 rounded-2" 
                        name="recurring_type" 
                        id="recurring_type"
                        style={{fontSize: '14px', borderColor: '#e9ecef', maxWidth: '200px'}}
                      >
                        <option value="">Select frequency</option>
                        <option value={1}>Daily</option>
                        <option value={2}>Weekly</option>
                        <option value={3}>Monthly</option>
                      </select>
                    </div>
                  )}
                </div>

                <div className="mb-3">
                  <label htmlFor="Description" className="form-label fw-medium text-dark mb-1" style={{fontSize: '13px'}}>
                    {t('Meeting Agenda')}
                  </label>
                  <textarea 
                    rows="3" 
                    onChange={(e) => setNote(e.target.value)} 
                    className="form-control py-2 px-3 rounded-2" 
                    id="Description" 
                    placeholder="Add meeting agenda, notes, or description (optional)"
                    style={{fontSize: '14px', resize: 'vertical', borderColor: '#e9ecef'}}
                  />
                </div>
              </div>
              {/* <div className="row">
                <div className="col-12">
                  <label htmlFor="cvpotos" className="form-label form-label-font-14">Cover Photos</label>
                  <div className="meeting-cover-photos position-relative" id="cvpotos">
                    <input className="meeting-cover-photos-choose-file" type="file" onChange={uploadHandler} accept="image/*" />
                    <div className="meeting-cover-photos-body">
                      <div className="text-center">
                        <i className="fas fa-cloud-upload" />
                        <span>Drag an image here or upload a file</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div> */}
              
              <ModalFooter className="border-0 pt-2 px-4 pb-3">
                <div className="d-flex justify-content-end gap-2 w-100">
                  <button 
                    type="button" 
                    onClick={props.handleShowB}
                    className="btn btn-light rounded-pill px-4 py-2"
                    style={{fontSize: '13px', fontWeight: '500'}}
                  >
                    Cancel
                  </button>
                  <button 
                    type="submit" 
                    className="btn btn-dark rounded-pill px-4 py-2"
                    style={{fontSize: '13px', fontWeight: '500'}}
                    disabled={loading}
                  >
                    {loading ? (
                      <>
                        <span
                          className="spinner-border spinner-border-sm me-2"
                          role="status"
                          aria-hidden="true"
                          style={{width: '14px', height: '14px'}}
                        ></span>
                        Creating...
                      </>
                    ) : (
                      <>
                        <i className="fa-solid fa-calendar-plus me-2" style={{fontSize: '12px'}}></i>
                        Schedule Meeting
                      </>
                    )}
                  </button>
                </div>
              </ModalFooter>
            </form>
          </div>
        </ModalBody>

      </Modal>

      <MeetingShare modalVisible={modalDialog} handleShow={() => setModalDialog(false)} shareData={sendToShareData} type={2} />
    </>
  )
}